import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import i18next from 'i18next';

import taxReceiptReducer from './taxReceiptReducer';

import TaxReceipt_en from './locales/TaxReceipt_en.json';
import TaxReceipt_fr from './locales/TaxReceipt_fr.json';

// Actions importation
import {
  onChangeDonationTypeField,
  clearTaxReceiptDonation,
  unmountTaxReceipt
} from './taxReceiptActions';

// Components importation
import TaxReceiptField from './public/components/fields/TaxReceiptFieldContainer';
import PublicInformationFields from './public/components/InformationFields';
import ConfirmationMessage from './public/components/ConfirmationMessage';
import GenerationNotice from './public/components/GenerationNotice';
import BillingInformation from './public/components/BillingInformation';
import AdminInformationFields from './admin/components/InformationFields';
import TaxReceiptTabRoute from './admin/components/TaxReceiptTabRoute';
import TaxReceiptCampaignSettingsTabRoute from './admin/components/TaxReceiptCampaignSettingsTabRoute';
import TaxReceiptAdminPage from './admin/pages/TaxReceiptAdminPageContainer';
import DashboardNotification from './admin/components/DashboardNotificationContainer';
import TaxReceiptButton from './admin/components/TaxReceiptButtonContainer';
import TaxReceiptCampaignSettingsPanel from './admin/components/TaxReceiptCampaignSettingsPanelContainer';

class TaxReceipt extends Component {
  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'TaxReceipt', TaxReceipt_en);
    i18next.addResourceBundle('fr', 'TaxReceipt', TaxReceipt_fr);

    // Actions listing
    this.actions = {
      onChangeDonationTypeField: props.onChangeDonationTypeField,
      clearTaxReceiptDonation: props.clearTaxReceiptDonation
    };

    // Components listing
    this.components = {
      TaxReceiptField: TaxReceiptField,
      PublicInformationFields: PublicInformationFields,
      ConfirmationMessage: ConfirmationMessage,
      GenerationNotice: GenerationNotice,
      BillingInformation: BillingInformation,
      AdminInformationFields: AdminInformationFields,
      TaxReceiptTabRoute: TaxReceiptTabRoute,
      TaxReceiptCampaignSettingsTabRoute: TaxReceiptCampaignSettingsTabRoute,
      AdminPage: TaxReceiptAdminPage,
      DashboardNotification: DashboardNotification,
      TaxReceiptButton: TaxReceiptButton,
      TaxReceiptCampaignSettingsPanel: TaxReceiptCampaignSettingsPanel
    };
  }

  componentWillUnmount() {
    //unmountTaxReceipt();
  }

  render() {
    const TaxReceiptComponent = this.props.component ? this.components[this.props.component] : null;

    return TaxReceiptComponent ? <TaxReceiptComponent {...this.props} /> : null;
  }
}

const mapStateToProps = state => ({
  TaxReceipt: state.TaxReceipt,
  state: state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onChangeDonationTypeField,
      clearTaxReceiptDonation
    },
    dispatch
  );

const view = connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(TaxReceipt);

export default {
  name: 'TaxReceipt',
  view,
  reducers: taxReceiptReducer
};
